
var wv={};
var baseUrl = 'https://portal.youthmath.org/20204';
var countryArray=[];
var isMalaysia = false;
wv$("input[name='contactEmail']").val(request.email);
function goToUri(customerRegistrationId,isSchool) {
    if(!customerRegistrationId || customerRegistrationId==null){
        window.location.href = '/pages/participants';
        return;
    }
    if(!isSchool || isSchool==null){
        window.location.href='/pages/admin';
    }

}
var customerRegistrationId =  localStorage.getItem("participant_id");
var isSchool = localStorage.getItem("is_school");
goToUri(customerRegistrationId,isSchool);
if(isSchool && isSchool.indexOf("individual")!=-1){
    //隐藏学校字段
    wv$(".school").hide();
}else{
    wv$(".school-regstration-header").text("SCHOOL REGISTRATION");
}
function tmcGetCountry(){
    if(countryArray){
        var country = wv$('#country');
        var macountry = wv$('#ma-country');
        var others = "";
        for (var i=0,len=countryArray.length;i<len;i++){
            if(countryArray[i].name=='Others'){
                others=countryArray[i];
            }else{
                country.append(wv$('<option>', {text: countryArray[i].name, value: countryArray[i].id}));
              macountry.append(wv$('<option>', {text: countryArray[i].name, value: countryArray[i].id}));
            }
            if(countryArray[i].name=='United States'){
                country.val(countryArray[i].id);
                macountry.val(countryArray[i].id);
                setStates(countryArray[i].id)
            }
        }
        country.append(wv$('<option>', {text: others.name, value: others.id}));
        country.change(function () {
            //变更之后修改states
            setStates(wv$(this).val())

        })
        macountry.append(wv$('<option>', {text: others.name, value: others.id}));
        macountry.change(function () {
            //变更之后修改states
            setStates(wv$(this).val())

        })
    }

}
function setStates(id) {
    var states = getStates(id);
    var state = wv$("#states");
    var mastate = wv$("#ma-states");
    state.empty();
    mastate.empty();
    if(states && states.length>0){
        for (var i=0,len=states.length;i<len;i++){
            state.append(wv$('<option>', {text: states[i].name, value: states[i].id}));
            mastate.append(wv$('<option>', {text: states[i].name, value: states[i].id}));
            if(i==0){
                state.val(states[i].id);
                mastate.val(states[i].id);
            }

        }
        wv$("#state-item").show();
        wv$("#ma-state-item").show();
        if (isMalaysia) {
            // Auto trigger state -> school type cascade on default/updated state.
            var currentMaStateName = wv$("#ma-states").find("option:selected").text();
            maSchoolTypeLoad(currentMaStateName);
        }
    }else {
        wv$("#state-item").hide();
        wv$("#ma-state-item").hide();
    }
}
function getStates(id) {
    for (var i=0,len=countryArray.length;i<len;i++){
        if(id==countryArray[i].id){
            return countryArray[i].provinces;
        }
    }
}

//获取客户考生信息
function getCustomerRegistration() {
    var data = {
        "myshopifyDomain": request.myshopifyDomain
    };
    wv$.ajax({
        url: baseUrl + "/store/customer/registration/info/"+customerRegistrationId,
        dataType: "json",
        data: JSON.stringify(data),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {},
        success: function (res) {
            wv$(".wvloading").hide();
            if(res.statusCode=="404"){
                window.location.href='/';
                return;
            }
            if(res.data && res.data.registration){
                var item = res.data.registration;
                if (item.countryId == 27) {
                  showMalaysia();
                  wv$("#ma-country").val(item.countryId);
                  wv$("#ma-country").prop('disabled', true);
                } else {
                  wv$("#country").val(item.countryId);
                  wv$("#country").prop('disabled', true);
                }

                wv$("input[name='fullName']").val(item.fullName);
              
                setStates(item.countryId);
            }
        },error: function (res) {wv$(".wvloading").hide();},complete: function(res) {}

    });
}

var status = 0;
//获取报名信息
function getParticipationInfo() {
    var data = {
        "myshopifyDomain": request.myshopifyDomain
    };
    //获取参加比赛信息
    wv$.ajax({
        url: baseUrl + "/store/customer/registration/participation/info/"+customerRegistrationId,
        dataType: "json",
        data: JSON.stringify(data),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {},
        success: function (res) {
            if(res.statusCode=="404"){
                window.location.href='/';
                return;
            }
            if(!res.data){
                window.location.href='/';
                return;
            }
            if(!res.data.record){
                getCustomerRegistration();
            }else{
                wv$(".wvloading").hide();
                var item = res.data.record;
                if(item.status>1){
                    window.location.href='/pages/apply-confirm';
                    return;
                }
                setStates(item.countryId);
                status = item.status;
                if (item.countryId == 27) {
                  wv$("input[name='fullName']").val(item.fullName || item.firstName + item.lastName);
                  wv$("#ma-country").val(item.countryId);
                  wv$("#ma-country").prop('disabled', true);
                  wv$("#ma-grade").val(item.grader);
                  wv$("#ma-states").val(item.statesId);
                  wv$("#ma-competitionLeve").val(item.competitionLevel);
                  updateMalaysiaCompetitionLevelOptions(false);
                  wv$("#gender").val(item.gender);
                  // Restore cascading school selection (state -> school type -> school)
                  var savedStateName = wv$("#ma-states").find('option:selected').text();
                  ensureMalaysiaSchoolData(function () {
                    maSchoolTypeLoad(savedStateName);
                    wv$("#shcooletype").val(item.schoolType);
                    if (item.schoolType) {
                      maSchoolLoad(savedStateName, String(item.schoolType));
                      if (String(item.schoolType) === "9") {
                        wv$("#ma-school-input-item").show();
                        wv$("input[name='schoolFullName']").val(item.schoolName || "");
                        return;
                      }
                      // Wait briefly for dropdown render, then restore saved school.
                      setTimeout(function () {
                        if (item.schoolName) {
                          wv$("#ma-school-select").val(item.schoolName);
                          if (!wv$("#ma-school-select").val()) {
                            // Not found in list -> treat as "Others" + keep typed name
                            wv$("#ma-school-select").val("__OTHERS__");
                            wv$("#ma-school-select-item").show();
                            wv$("#ma-school-input-item").show();
                            wv$("input[name='schoolFullName']").val(item.schoolName);
                          }
                        }
                      }, 0);
                    } else {
                      wv$("input[name='schoolFullName']").val(item.schoolName);
                    }
                  });
                  wv$("#race").val(item.race);
                  wv$("input[name='idnumber']").val(item.idNumber);
                  wv$("input[name='madateOfBirth']").val(item.dateOfBirth);
                  wv$("input[name='whatsapp']").val(item.whatsapp);
                  wv$("input[name='macontactEmail']").val(item.contactEmail);
                  isMalaysia = true;
                  wv$("#malaysia-content").show();
                  wv$("#other-country-content").hide();
                } else {
                  wv$("#competitionLeve").val(item.competitionLevel);
                  wv$("input[name='contactEmail']").val(item.contactEmail);
                  wv$("input[name='firstName']").val(item.firstName);
                  wv$("input[name='middleName']").val(item.middleName);
                  wv$("input[name='lastName']").val(item.lastName);
                  wv$("input[name='coachName']").val(item.coachName);
                  wv$("#grade").val(item.grader);
                  wv$("input[name='dateOfBirth']").val(item.dateOfBirth);
                  wv$("#country").val(item.countryId);
                  wv$("#states").val(item.statesId);
                  wv$("input[name='city']").val(item.city);
                  wv$("input[name='zipcode']").val(item.zipcode);
                  /*wv$("input[name='email']").val(item.email);*/
                  wv$("input[name='phone']").val(item.phone);
                  wv$("input[name='schoolName']").val(item.schoolName);
                  wv$("input[name='schoolZipcode']").val(item.schoolZipcode);
                  wv$("#country").prop('disabled', true);
                }

            }

        },error: function (res) {wv$(".wvloading").hide();},complete: function(res) {}

    });
}

if(customerRegistrationId==null || !customerRegistrationId){
    window.location.href = '/pages/participants';
}

if(countryArray.length===0){
    var data = {
        "customerId": request.shopifyCustomerId,
        "myshopifyDomain": request.myshopifyDomain
    };
    //获取国家数据
    wv$.ajax({
        url: baseUrl + "/store/customer/regions",
        dataType: "json",
        data: JSON.stringify(data),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {
            wv$(".wvloading").show();
        },
        success: function (res) {
            wv$(".wvloading").hide();
            if(res.statusCode=="404"){
                return;
            }
            if(res.data && res.data.regions){
                countryArray = res.data.regions;
                tmcGetCountry();
              getParticipationInfo();
            }

        },error: function (res) { wv$(".wvloading").hide();},complete: function(res) {}

    });
}


function recordCount() {
    var data = {
        "customerId": request.shopifyCustomerId,
        "myshopifyDomain": request.myshopifyDomain
    };
    //获取已报名数量
    wv$.ajax({
        url: baseUrl + "/store/customer/registration/recordCount",
        dataType: "json",
        data: JSON.stringify(data),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {},
        success: function (res) {
            if(res.statusCode=="404"){
                window.location.href='/';
                return;
            }
            if(res.data && res.data.recordCount && res.data.recordCount>0){
                wv$("#country").val(res.data.countryId);
                wv$("#country").prop('disabled', true);
                wv$("#ma-country").val(res.data.countryId);
                wv$("#ma-country").prop('disabled', true);
            }else{
                wv$("#country").prop('disabled', false);
            }

        },error: function (res) {wv$(".wvloading").hide();},complete: function(res) {}

    });
}
//recordCount();

// 文案长度过滤
wv.lengthFilter = function(str,minLength,maxLength){
    return wv$.trim(str).length >= minLength && (maxLength ? wv$.trim(str).length <= maxLength : true);
};
wv.validatePhoneNumber = function(phoneNumber) {
    // 正则表达式匹配国际电话号码，例如：+1-202-555-0173
    var regex = /^(\+|\d{1,3})\s?(\d{1,4})?\s?\(?\d{1,4}\)?\s?\d{1,4}\s?\-?\d{1,9}$/;
    return regex.test(phoneNumber);
};

function aptEmailFilter(str) {
    if(!str){
        return false;
    }
    if (str.length > 64) {
        return false
    }
    str = str.toLowerCase();
    var regx = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
    if (!regx.test(str)) {
        return false
    }
    return true
}
// ─── Helpers ────────────────────────────────────────────────────────────────

/** Collect all form values into a plain object (used for validation + modal) */
function collectFormData() {
    var firstName = wv$("input[name='firstName']").val();
    var middleName = wv$("input[name='middleName']").val();
    var lastName = wv$("input[name='lastName']").val();
    var fullName = wv$("input[name='fullName']").val();
    var coachName = wv$("input[name='coachName']").val();
    var phone = wv$("input[name='phone']").val();
    var contactEmail = wv$("input[name='contactEmail']").val();
    var macontactEmail = wv$("input[name='macontactEmail']").val();
    var grader = wv$("#grade").val();
    var graderText = wv$("#grade").find('option:selected').text();
    var magrader = wv$("#ma-grade").val();
    var magraderText = wv$("#ma-grade").find('option:selected').text();
    var dateOfBirth = wv$("input[name='dateOfBirth']").val();
    var madateOfBirth = wv$("input[name='madateOfBirth']").val();
    var countryId = wv$("#country").val();
    var macountryId = wv$("#ma-country").val();
    var country = wv$("#country").find('option:selected').text();
    var macountry = wv$("#ma-country").find('option:selected').text();
    var statesId = wv$("#states").val();
    var states = wv$("#states").find('option:selected').text();
    var mastatesId = wv$("#ma-states").val();
    var mastates = wv$("#ma-states").find('option:selected').text();
    var city = wv$("input[name='city']").val();
    var macityVal = wv$("#ma-states").find('option:selected').text();
    var zipcode = wv$("input[name='zipcode']").val();
    var competitionLevel = wv$("#competitionLeve").val();
    var competitionLevelText = wv$("#competitionLeve").find('option:selected').text();
    var macompetitionLevel = wv$("#ma-competitionLeve").val();
    var macompetitionLevelText = wv$("#ma-competitionLeve").find('option:selected').text();
    var schoolName = wv$("#schoolName").val();
    var maSchoolSelectVal = wv$("#ma-school-select").val();
    var schoolFullName = (maSchoolSelectVal && maSchoolSelectVal !== "__OTHERS__")
        ? maSchoolSelectVal
        : wv$("#schoolFullName").val();
    var schoolZipcode = wv$("input[name='schoolZipcode']").val();
    var shcooletypeId = wv$("#shcooletype").val();
    var shcooletype = wv$("#shcooletype").find('option:selected').text();
    var genderId = wv$("#gender").val();
    var genderText = wv$("#gender").find('option:selected').text();
    var raceId = wv$("#race").val();
    var raceText = wv$("#race").find('option:selected').text();
    var idnumberId = wv$("input[name='idnumber']").val();
    var whatsapp = wv$("input[name='whatsapp']").val();

    return {
        firstName: firstName, middleName: middleName, lastName: lastName,
        fullName: fullName, coachName: coachName, phone: phone,
        contactEmail: contactEmail, macontactEmail: macontactEmail,
        grader: grader, graderText: graderText,
        magrader: magrader, magraderText: magraderText,
        dateOfBirth: dateOfBirth, madateOfBirth: madateOfBirth,
        countryId: countryId, country: country,
        macountryId: macountryId, macountry: macountry,
        statesId: statesId, states: states,
        mastatesId: mastatesId, mastates: mastates,
        city: city, macityVal: macityVal,
        zipcode: zipcode,
        competitionLevel: competitionLevel, competitionLevelText: competitionLevelText,
        macompetitionLevel: macompetitionLevel, macompetitionLevelText: macompetitionLevelText,
        schoolName: schoolName, schoolFullName: schoolFullName,
        schoolZipcode: schoolZipcode,
        shcooletypeId: shcooletypeId, shcooletype: shcooletype,
        genderId: genderId, genderText: genderText,
        raceId: raceId, raceText: raceText,
        idnumberId: idnumberId, whatsapp: whatsapp
    };
}

/** Build final API payload from collected form data */
function buildApiPayload(f, type) {
    var data = {
        "customerRegistrationId": customerRegistrationId,
        "myshopifyDomain": request.myshopifyDomain,
        "shopifyCustomerId": request.shopifyCustomerId,
        "competitionLevel": f.competitionLevel,
        "email": request.email,
        "firstName": f.firstName,
        "middleName": f.middleName,
        "lastName": f.lastName,
        "coachName": f.coachName,
        "phone": f.phone,
        "contactEmail": f.contactEmail,
        "grader": f.grader,
        "dateOfBirth": f.dateOfBirth,
        "country": f.country,
        "countryId": f.countryId,
        "states": f.states,
        "statesId": f.statesId,
        "city": f.city,
        "zipcode": f.zipcode,
        "type": type
    };
    if (isSchool.indexOf("individual") == -1 && isMalaysia == false) {
        data.schoolName = f.schoolName;
        data.schoolZipcode = f.schoolZipcode;
    }
    if (isMalaysia == true) {
        data = {
            "customerRegistrationId": customerRegistrationId,
            "myshopifyDomain": request.myshopifyDomain,
            "shopifyCustomerId": request.shopifyCustomerId,
            "fullName": f.fullName.toUpperCase(),
            "country": f.macountry,
            "countryId": f.macountryId,
            "grader": f.magrader,
            "states": f.mastates,
            "statesId": f.mastatesId,
            "city": "",
            "competitionLevel": f.macompetitionLevel,
            "schoolType": f.shcooletypeId,
            "gender": f.genderId,
            "schoolName": f.schoolFullName.toUpperCase(),
            "idNumber": f.idnumberId.toUpperCase(),
            "race": f.raceId,
            "whatsapp": f.whatsapp,
            "dateOfBirth": f.madateOfBirth,
            "contactEmail": f.macontactEmail,
            "email": request.email
        };
    }
    return data;
}

/** Render confirmation modal rows from collected form data */
function buildConfirmRows(f) {
    var rows = [];
    function row(label, value) {
        if (value) rows.push({ label: label, value: value });
    }
    if (isMalaysia) {
        row("Full Name",          f.fullName ? f.fullName.toUpperCase() : "");
        row("Country",            f.macountry);
        row("Grade",              f.magraderText);
        row("State",              f.mastates);
        row("Competition Level",  f.macompetitionLevelText);
        row("School Type",        f.shcooletype);
        row("School Name",        f.schoolFullName ? f.schoolFullName.toUpperCase() : "");
        row("Gender",             f.genderText);
        row("Race",               f.raceText);
        row("IC Number / Passport",          f.idnumberId ? f.idnumberId.toUpperCase() : "");
        row("Date of Birth",      f.madateOfBirth);
        row("WhatsApp",           f.whatsapp);
    } else {
        row("Competition Level",  f.competitionLevelText);
        row("First Name",         f.firstName);
        row("Middle Name",        f.middleName);
        row("Last Name",          f.lastName);
        row("Coach Name",         f.coachName);
        row("Grade",              f.graderText);
        row("Date of Birth",      f.dateOfBirth);
        row("Country",            f.country);
        row("State",              f.states);
        row("City",               f.city);
        row("Zipcode",            f.zipcode);
        row("Phone",              f.phone);
        if (isSchool && isSchool.indexOf("individual") == -1) {
            row("School Name",    f.schoolName);
            row("School Zipcode", f.schoolZipcode);
        }
    }
    return rows;
}

/** Show the confirmation modal with given rows */
function showConfirmModal(rows) {
    var body = wv$("#reg-confirm-body");
    body.empty();
    for (var i = 0; i < rows.length; i++) {
        body.append(
            '<div class="reg-confirm-row">' +
            '<span class="reg-confirm-label">' + rows[i].label + '</span>' +
            '<span class="reg-confirm-value">' + rows[i].value + '</span>' +
            '</div>'
        );
    }
    wv$("#reg-confirm-error").text("");
    wv$("#reg-confirm-overlay").css("display", "flex");
    wv$("#reg-confirm-body").scrollTop(0);
}

/** Perform the actual API submission */
function doSubmitApi(data) {
    var confirmBtn = wv$("#reg-confirm-submit");
    var backBtn    = wv$("#reg-confirm-back");
    wv$.ajax({
        url: baseUrl + "/store/customer/registration/participation",
        dataType: "json",
        data: JSON.stringify(data),
        type: "POST",
        contentType: "application/json;charset=UTF-8",
        async: true,
        beforeSend: function () {
            wv$(".wvloading").show();
            confirmBtn.attr("disabled", true);
            backBtn.attr("disabled", true);
            wv$("#reg-confirm-error").text("");
        },
        success: function (res) {
            wv$(".wvloading").hide();
            confirmBtn.attr("disabled", false);
            backBtn.attr("disabled", false);
            if (res.code == "error") {
                wv$("#reg-confirm-error").text(res.message);
            } else {
                wv$("#reg-confirm-overlay").hide();
                if (status && status > 1) {
                    window.location.href = "/pages/apply-confirm";
                } else {
                    window.location.href = "/pages/test-list";
                }
            }
        },
        error: function (res) {
            wv$(".wvloading").hide();
            confirmBtn.attr("disabled", false);
            backBtn.attr("disabled", false);
            wv$("#reg-confirm-error").text(res.message || "Submission failed. Please try again.");
        }
    });
}

// ─── Submit button: validate → show confirmation modal ──────────────────────
// Stores pending payload so the confirm button can fire it
var _pendingPayload = null;

wv$(".school-regstration-submit").on("click", function () {
    wv$(".wooview-apt-error").text("");
    var f = collectFormData();
    var type = 1;

    if (isMalaysia == false) {
      if (!f.competitionLevel) {
        wv$("#competitionLeve").focus();
        wv$(".wooview-apt-error").text("Please select the level.");
        return;
      }
      if (isSchool.indexOf("individual") == -1) {
          type = 2;
          if (!f.schoolName) {
              wv$("#schoolName").focus();
              wv$(".wooview-apt-error").text("Please select the school name.");
              return;
          }
          if (!f.schoolZipcode) {
              wv$("input[name='schoolZipcode']").focus();
              wv$(".wooview-apt-error").text("Please select the school ZIP Code.");
              return;
          }
      }
      if (!wv.lengthFilter(f.firstName, 1, 50)) {
          wv$("input[name='firstName']").focus();
          wv$(".wooview-apt-error").text("Please enter the first name.");
          return;
      }
      if (!wv.lengthFilter(f.lastName, 1, 50)) {
          wv$("input[name='lastName']").focus();
          wv$(".wooview-apt-error").text("Please enter the last name.");
          return;
      }
      if (!wv.validatePhoneNumber(f.phone)) {
          wv$("input[name='phone']").focus();
          wv$(".wooview-apt-error").text("Please enter the phone number.");
          return;
      }
    } else {
      if (!wv.lengthFilter(f.fullName, 1, 50)) {
          wv$("input[name='fullName']").focus();
          wv$(".wooview-apt-error").text("Please enter the full name.");
          return;
      }
      if (!f.macountryId) {
          wv$("#ma-country").focus();
          wv$(".wooview-apt-error").text("Please select the country.");
          return;
      }
      if (!f.magrader) {
          wv$("#ma-grade").focus();
          wv$(".wooview-apt-error").text("Please select the grade.");
          return;
      }
      if (!f.mastatesId) {
          wv$("#ma-states").focus();
          wv$(".wooview-apt-error").text("Please select the state.");
          return;
      }
      if (!f.macompetitionLevel) {
          wv$("#ma-competitionLeve").focus();
          wv$(".wooview-apt-error").text("Please select the level.");
          return;
      }
      if (!f.shcooletypeId) {
          wv$("#shcooletype").focus();
          wv$(".wooview-apt-error").text("Please select the school type.");
          return;
      }
      if (!f.genderId) {
          wv$("#gender").focus();
          wv$(".wooview-apt-error").text("Please select the gender.");
          return;
      }
      if (!f.schoolFullName) {
          if (wv$("#ma-school-select-item").is(":visible")) {
              wv$("#ma-school-select").focus();
              wv$(".wooview-apt-error").text("Please select the school name.");
          } else {
              wv$("#schoolFullName").focus();
              wv$(".wooview-apt-error").text("Please enter the school name.");
          }
          return;
      }
      if (!f.raceId) {
          wv$("#race").focus();
          wv$(".wooview-apt-error").text("Please select the race.");
          return;
      }
      if (!f.madateOfBirth || !/^\d{4}-\d{2}-\d{2}$/.test(f.madateOfBirth)) {
          wv$("#ma-dateOfBirth").focus();
          wv$(".wooview-apt-error").text("Please select a valid date of birth (use the calendar picker).");
          return;
      }
      if (!f.whatsapp) {
          wv$("#whatsapp").focus();
          wv$(".wooview-apt-error").text("Please enter the WhatsApp number.");
          return;
      }
    }

    // Validation passed — build payload, store it, show confirmation modal
    _pendingPayload = buildApiPayload(f, type);
    showConfirmModal(buildConfirmRows(f));
});

// ─── Confirmation modal buttons ─────────────────────────────────────────────

// "Back to Edit": close modal, return to form
wv$("#reg-confirm-back").on("click", function () {
    wv$("#reg-confirm-overlay").hide();
    _pendingPayload = null;
});

// "Confirm & Submit": fire the API
wv$("#reg-confirm-submit").on("click", function () {
    if (!_pendingPayload) return;
    doSubmitApi(_pendingPayload);
});

// Close modal when clicking the dark overlay background
wv$("#reg-confirm-overlay").on("click", function (e) {
    if (wv$(e.target).is("#reg-confirm-overlay")) {
        wv$("#reg-confirm-overlay").hide();
        _pendingPayload = null;
    }
});

wv$("#grade").on("change",function () {
    var val = wv$(this).val();
    if(val && val.length>0){
        val=parseInt(val);
    }
    if(val==1 || val==2){
        wv$("#competitionLeve").val(1);
    }
    if(val==3 || val==4){
        wv$("#competitionLeve").val(2);
    }
    if(val==5 || val==6){
        wv$("#competitionLeve").val(3);
    }
});

function showMalaysia () {
  isMalaysia = true;
  wv$("#malaysia-content").show();
  wv$("#other-country-content").hide();
  arrangeMalaysiaSchoolFields();
  ensureMalaysiaSchoolData();
  updateMalaysiaCompetitionLevelOptions(false);
  tmcGetCountry();
};

function hideMalaysia () {
  isMalaysia = false;
  wv$("#malaysia-content").hide();
  wv$("#other-country-content").show();
  tmcGetCountry();
};

// ─── Malaysia cascading school selection ───────────────────────────────────
// Fallbacks so this file still works even if tmc.malaysia-schools.js is not loaded.
var malaysiaSchoolData = (typeof malaysiaSchoolData !== "undefined" && malaysiaSchoolData) ? malaysiaSchoolData : {};
var schoolTypeIdToKey = (typeof schoolTypeIdToKey !== "undefined" && schoolTypeIdToKey) ? schoolTypeIdToKey : {
  "1": "SK",
  "2": "SJKC",
  "3": "SJKT",
  "5": "SK KHAS",
  "6": "SR SABK",
  "7": "K9"
};

var _malaysiaStateKeyAliases = {
  "KUALA LUMPUR": "WILAYAH PERSEKUTUAN KU",
  "LABUAN": "WILAYAH PERSEKUTUAN LA",
  "PUTRAJAYA": "WILAYAH PERSEKUTUAN PU",
  "PENANG": "PULAU PINANG",
  "PULAU PINANG": "PULAU PINANG",
  "MALACCA": "MELAKA"
};

function _normalizeMalaysiaStateName(name) {
  if (!name) return "";
  return String(name)
    .toUpperCase()
    .replace(/\./g, "")
    .replace(/\s+/g, " ")
    .trim();
}

function _getMalaysiaStateKey(stateName) {
  var normalized = _normalizeMalaysiaStateName(stateName);
  if (!normalized) return "";
  if (malaysiaSchoolData[normalized]) return normalized;
  if (_malaysiaStateKeyAliases[normalized]) return _malaysiaStateKeyAliases[normalized];
  return "";
}

function _getMalaysiaSchoolsByType(stateName, schoolTypeKey) {
  var stateKey = _getMalaysiaStateKey(stateName);
  if (!stateKey || !schoolTypeKey) return [];
  var stateData = malaysiaSchoolData[stateKey];
  if (!stateData) return [];
  return stateData[schoolTypeKey] || [];
}

var _isMalaysiaSchoolDataLoaded = false;
var _isMalaysiaSchoolDataLoading = false;
var _malaysiaSchoolDataCallbacks = [];
var _maCompetitionOptionsCache = null;

function ensureMalaysiaSchoolData(done) {
  if (_isMalaysiaSchoolDataLoaded) {
    if (typeof done === "function") done();
    return;
  }
  if (typeof done === "function") _malaysiaSchoolDataCallbacks.push(done);

  if (_isMalaysiaSchoolDataLoading) return;
  _isMalaysiaSchoolDataLoading = true;

  var dropdownUrl = window.malaysiaSchoolDropdownUrl || "";
  if (!dropdownUrl) {
    _isMalaysiaSchoolDataLoaded = true;
    _isMalaysiaSchoolDataLoading = false;
    while (_malaysiaSchoolDataCallbacks.length) {
      _malaysiaSchoolDataCallbacks.shift()();
    }
    return;
  }

  wv$.ajax({
    url: dropdownUrl,
    dataType: "json",
    type: "GET",
    cache: true,
    success: function (res) {
      if (res && typeof res === "object") {
        malaysiaSchoolData = res;
      }
    },
    complete: function () {
      _isMalaysiaSchoolDataLoaded = true;
      _isMalaysiaSchoolDataLoading = false;
      while (_malaysiaSchoolDataCallbacks.length) {
        _malaysiaSchoolDataCallbacks.shift()();
      }
    }
  });
}

function arrangeMalaysiaSchoolFields() {
  var stateItem = wv$("#ma-state-item");
  var schoolTypeItem = wv$("#ma-schooltype-item");
  var schoolSelectItem = wv$("#ma-school-select-item");
  var schoolInputItem = wv$("#ma-school-input-item");
  if (!stateItem.length) return;
  schoolTypeItem.insertAfter(stateItem);
  schoolSelectItem.insertAfter(schoolTypeItem);
  schoolInputItem.insertAfter(schoolSelectItem);
}

function getMaSelectSchoolText() {
  return window.maSelectSchoolText || "School Full Name";
}

function getMalaysiaExactLevelByGrade(gradeValue) {
  var g = parseInt(gradeValue, 10);
  if (g === 1) return 1; // K2 -> Level 1
  if (g === 2 || g === 3) return 2; // Std1-2 -> Level 2
  if (g === 4 || g === 5) return 3; // Std3-4 -> Level 3
  if (g === 6 || g === 7) return 4; // Std5-6 -> Level 4
  return 1;
}

function updateMalaysiaCompetitionLevelOptions(resetToMin) {
  var levelSelect = wv$("#ma-competitionLeve");
  if (!levelSelect.length) return;

  if (!_maCompetitionOptionsCache) {
    _maCompetitionOptionsCache = [];
    levelSelect.find("option").each(function () {
      _maCompetitionOptionsCache.push({
        value: String(wv$(this).val()),
        text: wv$(this).text()
      });
    });
  }

  var exactLevel = getMalaysiaExactLevelByGrade(wv$("#ma-grade").val());
  levelSelect.empty();

  for (var i = 0; i < _maCompetitionOptionsCache.length; i++) {
    var opt = _maCompetitionOptionsCache[i];
    if (parseInt(opt.value, 10) === exactLevel) {
      levelSelect.append(wv$("<option>", { value: opt.value, text: opt.text }));
    }
  }

  levelSelect.val(String(exactLevel));
}

/**
 * Show school type picker if selected state has data.
 */
function maSchoolTypeLoad(stateName) {
  wv$("#ma-schooltype-item").hide();
  wv$("#ma-school-select-item").hide();
  wv$("#ma-school-input-item").hide();
  wv$("#shcooletype").val("");
  wv$("#ma-school-select").empty().append(wv$("<option>", { value: "", text: getMaSelectSchoolText(), disabled: true, selected: true, hidden: true }));
  wv$("input[name='schoolFullName']").val("");

  ensureMalaysiaSchoolData(function () {
    var stateKey = _getMalaysiaStateKey(stateName);
    if (!stateKey || !malaysiaSchoolData[stateKey]) return;
    wv$("#ma-schooltype-item").show();
  });
}

/**
 * Populate school dropdown based on state + school type numeric ID.
 */
function maSchoolLoad(stateName, schoolTypeId) {
  wv$("#ma-school-select-item").hide();
  wv$("#ma-school-input-item").hide();
  wv$("#ma-school-select").empty().append(wv$("<option>", { value: "", text: getMaSelectSchoolText(), disabled: true, selected: true, hidden: true }));
  wv$("input[name='schoolFullName']").val("");

  if (!schoolTypeId) return;

  var schoolTypeKey = schoolTypeIdToKey[schoolTypeId];

  if (!stateName) return;
  ensureMalaysiaSchoolData(function () {
    var schools = _getMalaysiaSchoolsByType(stateName, schoolTypeKey);
    if (!schools || schools.length === 0) {
      // If no preset schools for this type, allow user to type.
      wv$("#ma-school-input-item").show();
      return;
    }

    var schoolSelect = wv$("#ma-school-select");
    schoolSelect.append(wv$('<option value="__OTHERS__">Others</option>'));

    for (var i = 0; i < schools.length; i++) {
      schoolSelect.append(wv$('<option>', { text: schools[i], value: schools[i] }));
    }

    wv$("#ma-school-select-item").show();
  });
}

// Wire up cascading events
arrangeMalaysiaSchoolFields();
updateMalaysiaCompetitionLevelOptions(false);

wv$("#ma-grade").on("change", function () {
  // Grade maps to one exact competition level.
  updateMalaysiaCompetitionLevelOptions(true);
});

wv$("#ma-states").on("change", function () {
  var stateName = wv$(this).find('option:selected').text();
  maSchoolTypeLoad(stateName);
});

wv$("#shcooletype").on("change", function () {
  var stateName = wv$("#ma-states").find('option:selected').text();
  var schoolType = wv$(this).val();
  maSchoolLoad(stateName, schoolType);
});

// When "Others" is selected from school dropdown, show free text input
wv$("#ma-school-select").on("change", function () {
  if (wv$(this).val() === "__OTHERS__") {
    wv$("#ma-school-input-item").show();
    wv$("input[name='schoolFullName']").val("");
  } else {
    wv$("#ma-school-input-item").hide();
  }
});